import styled from 'styled-components';
import * as React from 'react';

import { Line } from '../ui/divider/Line';
import { Link } from 'react-router-dom';

export const HeaderBottomStyle = styled((props) => <Link {...props} />)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  align-items: center;
  text-align: center;
  padding: 35px 30px;
  color: ${({ theme }) => theme.colors.primary};
  p {
    color: ${({ theme }) => theme.colors.white};
  }

  @media all and (max-width: 450px) {
    padding-top:2em;
    padding-bottom: 0;
    p {
      font-size: 14px;
    }

    :last-child {
      padding-bottom:1em;
    }
  }
`;

const Title = styled.h3`
  @media all and (max-width: 450px) {
    font-size: 25px;
  }
`;

export const HeaderSpace = styled.div`
  margin: 3px;
`;

export const HeaderBottomCard: React.FC<{
  title: string;
  text: string;
  link?: string;
}> = ({ title, text, link }) => {
  return (
    <HeaderBottomStyle to={link}>
      <Title>{title}</Title>
      <Line />
      <HeaderSpace>
        <p>{text}</p>
      </HeaderSpace>
    </HeaderBottomStyle>
  );
};
